import { render, staticRenderFns } from "./retailerTerms.vue?vue&type=template&id=0e1433a6&lang=pug"
import script from "./retailerTerms.vue?vue&type=script&lang=js"
export * from "./retailerTerms.vue?vue&type=script&lang=js"
import style0 from "./retailerTerms.vue?vue&type=style&index=0&id=0e1433a6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports